import { Box, Paper } from "@mui/material";
import { SawScheduleBudget } from "../models/types";
import { CardBodySx, CardPaperSx, CardTitle, InfoGrid } from "./primitives";

type Props = {
	data?: SawScheduleBudget | null;
};

const sec = (v: number | null | undefined): string | null =>
	v != null ? `${v.toFixed(1)} sec` : null;

// "Cycle Times" — per cut, average and last.
export const CycleTimesCard = ({ data = null }: Props) => (
	<Paper elevation={1} sx={CardPaperSx}>
		<CardTitle title="Cycle Times" />

		<Box sx={CardBodySx}>
			<InfoGrid
				columns={1}
				items={[
					{
						label: "Avg Cycle Time per Cut",
						value: sec(data?.avgCycleTimePerCut),
					},
					{
						label: "Cycle Time per Last Cut",
						value: sec(data?.cycleTimePerLastCut),
					},
				]}
			/>
		</Box>
	</Paper>
);
